module.exports = __webpack_public_path__ + "static/media/records-accent-light.ca28eaf4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/records-accent-light.svg
// module id = 701
// module chunks = 0